import { GeoJsonLayer } from "@deck.gl/layers";

export function getLocationHighlight(geoJsonLocation: any): GeoJsonLayer<any> {
  return new GeoJsonLayer({
    id: 'highlight_point',
    data: geoJsonLocation,
    pickable: false,
    autoHighlight: false,
    pointType: 'circle',
    getPointRadius: 0.2,
    pointRadiusMaxPixels: 60,
    pointRadiusMinPixels: 15,
    pointRadiusUnits: 'common',
    getFillColor: [46, 204, 64, 180],
    getLineColor: [255, 255, 255, 0]
  });
}
